import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhonePipe } from './phone/phone.pipe';
import { CapitalizeNamePipe } from './capitalize-name/capitalize-name.pipe';
import { SmartCurrencyPipe } from './smart-currency/smart-currency.pipe';
import { DisplayDatePipe } from './display-date/display-date.pipe';

@NgModule({
  declarations: [
    PhonePipe,
    CapitalizeNamePipe,
    SmartCurrencyPipe,
    DisplayDatePipe,
  ],
  imports: [CommonModule],
  exports: [PhonePipe, CapitalizeNamePipe, SmartCurrencyPipe, DisplayDatePipe],
})
export class PipesModule {}
